// Dependencies
import React, { Component } from 'react';

// Primereact imports
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

// Multi lang
import { withTranslation } from 'react-multi-lang';

// Styling
import './professional-name.scss';

// Utils
import { CEDULA_COM_ENTREGA_PRODUCT, CEDULA_SEM_ENTREGA_PRODUCT, PRODUCT_KEY_PROFESSIONAL_NAME } from '../../../common/constants';

// Redux
import AssociateService from '../../../redux/services/associate';
import { updateBasket } from '../../../redux/actions/order';
import { connect } from 'react-redux';

class ProfessionalNameComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            professionalName: "",
            validProduct: true,
            validProfessionalName: true,
            hasProfessionalName: true,
            existingProfessionalName: false
        }
    }

    updateFormComponent(column, value) {
        this.setState({
            [column]: value
        })
    }

    submitAcquisition() {
        this.setState({
            existingProfessionalName: false,
            validProfessionalName: true,
            hasProfessionalName: true,
        });

        if(this.validateForm()) {
            AssociateService.checkProfessionalName(this.props.associate.associateId, this.state.professionalName).then((response) => { 
                this.setState({
                    existingProfessionalName: response.exists,
                    validProfessionalName: response.valid
                });

                if(!response.exists && response.valid) {
                    let metadata = [
                        { key: PRODUCT_KEY_PROFESSIONAL_NAME, value: this.state.professionalName }
                    ];
        
                    // Add product to basket
                    let product = this.props.product;
                    product.metadata = metadata;
                    product.title = this.props.t("products.products." + product.title) + " - " + this.state.professionalName;
        
                    let products = [];

                    for (let i = 0; i < this.props.basketProducts.length; i++) {
                        products.push(this.props.basketProducts[i]);
                        
                    }
        
                    products.push(product);
        
                    this.props.updateBasket(products, this.props.basketTrainings);
                    this.props.onClose();
                }
            })
            .catch(error => { });
        }
    }

    validateForm() {
        let validProduct = true;

        for (let i = 0; i < this.props.basketProducts.length; i++) {
            if(this.props.basketProducts[i].productRef === CEDULA_SEM_ENTREGA_PRODUCT || this.props.basketProducts[i].productRef === CEDULA_COM_ENTREGA_PRODUCT) {
                validProduct = false;
                break;
            }
        }

        this.setState({
            validProduct: validProduct,
            hasProfessionalName: this.state.professionalName !== ""
        });

        let validationResult = (validProduct && this.state.professionalName !== "");

        return validationResult;
    }

    render() {
        return (
            <div className="grid mgt-10">
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.info-note")}</b>
                </div>
                <div className="col-12" style={{textAlign: "justify"}}>
                    <ul style={{marginLeft: "20px", padding: 0}}>
                        <li style={{marginBottom: "10px"}}>{this.props.t("products.labels.ballot-address")}</li>
                    </ul>
                </div>
                <div className="col-12" style={{fontSize: "14px"}}>
                    <b>{this.props.t("products.labels.product-form")}</b>
                </div>
                <div className="col-12">
                    <div className="flex flex-column gap-2">
                        <label htmlFor="professional-name">{this.props.t("products.labels.professional-name")}</label>
                        <InputText value={this.state.professionalName} id="professional-name" type="text" onChange={(evt) => this.updateFormComponent("professionalName", evt.target.value)}/>
                        { this.state.hasProfessionalName ? null : <small className="p-error">{this.props.t("general.mandatory-field")}</small>  }
                        { !this.state.existingProfessionalName ? null : <small className="p-error">{this.props.t("products.messages.existing-professional-name")}</small>  }
                        { this.state.validProfessionalName ? null : <small className="p-error">{this.props.t("products.messages.invalid-professional-name")}</small>  }
                        { this.state.validProduct ? null : <small className="p-error">{this.props.t("products.messages.invalid-ballot-request")}</small>  }
                    </div>
                </div>
                <div className='col-12 t-align-right'>
                    <div className="flex flex-wrap justify-content-end gap-2">  
                        <Button label={this.props.t("products.labels.add")} icon="pi pi-shopping-cart" onClick={(evt) => this.submitAcquisition() }/>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        associate: state.profile.associate,
        basketProducts: state.store.basketProducts,
        basketTrainings: state.store.basketTrainings
    } 
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateBasket: (basketProducts, basketTrainings) => { dispatch(updateBasket(basketProducts, basketTrainings)) }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(ProfessionalNameComponent));